module.exports = __webpack_public_path__ + "static/media/thumbtack.1cae7543.svg";